import { render, staticRenderFns } from "./_course_id.vue?vue&type=template&id=2b6639c3&scoped=true&"
import script from "./_course_id.vue?vue&type=script&lang=js&"
export * from "./_course_id.vue?vue&type=script&lang=js&"
import style0 from "./_course_id.vue?vue&type=style&index=0&id=2b6639c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6639c3",
  null
  
)

export default component.exports